import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form, InputGroup, FormControl } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import camera from '../assets/images/svg/camera.svg';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const CategoryStyle = (props) => {

    const serverURL = getServerURL()
    const fileInputRef = useRef(null);

    const [modalShow, setModalShow] = useState(false);
    const modalOpen = () => {
        setModalShow(true)
        getMainCategory();
    }
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [searchText, setSearchText] = useState("");


    const [states, setStates] = useState({})
    const [mainCategoryData, setMainCategoryData] = useState([])
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([])
    const [deleteData, setDeleteData] = useState()
    const [loading, setLoading] = useState(true)
    const [subLoader, setSubLoader] = useState(false);
    const [mode, setMode] = useState()
    const [selectedImage, setSelectedImage] = useState()
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)
    const [subCategoryData, setSubCategoryData] = useState([])

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    useEffect(() => {
        getCategoryStyle();
    }, [searchText, page]);

    useEffect(() => {
        if (mode === false) {
            if (states?.subType !== "engagement-rings") {
                getMainCategory(states?.type)
            }
        }
    }, [states?.type]);

    const getCategoryStyle = (event) => {
        api.getWithToken(`${serverURL}product/style/?page=${page}${searchText && `&_i=${searchText}`}`)
            .then(async (res) => {
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                setLoading(false)
                if (res?.data?.success === true) {
                    setData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const getMainCategory = (type) => {
        api.getWithToken(`${serverURL}create-product/category/${Boolean(type) ? `?_i=${type}` : ""}`)
            .then(async (res) => {
                if (type) {
                    if (res?.data?.data?.length)
                        setSubCategoryData(res?.data?.data);
                } else
                    if (res?.data?.success === true) {
                        setMainCategoryData(res?.data?.data);
                    }
            })
            .catch((e) => {
            });
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "image") {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setSelectedImage(reader.result);
                };
                reader.readAsDataURL(file);
                setStates({
                    ...states,
                    [name]: file,
                });
            }
        } else
            setStates((prevValues) => ({
                ...prevValues,
                [name]: value,
            }));
    };

    const handleSubmit = (event) => {
        setSubLoader(true)
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity()) {
            setValidated(false);
            const type = Boolean(mode) ? "postWithToken" : "putWithToken";
            const formData = new FormData();
            formData.append("name", states?.name);
            formData.append("image", states?.image);
            formData.append("type", states?.type);
            formData.append("subType", states?.subType);
            if (states?.slug)
                formData.append("slug", states?.slug);


            api[type](`${serverURL}product/style/`, formData)
                .then(async (res) => {
                    setModalShow(false)
                    setStates({})
                    form.reset();
                    setLoading(false);
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getCategoryStyle();
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setSubLoader(false)
                    errorResponse(e);
                });
        } else {
            setValidated(true);
            setSubLoader(false)
            event.stopPropagation();
        }
    };

    const deleteCategoryStyle = () => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}product/style/${deleteData}`)
            .then(async (res) => {
                setSubLoader(false)
                setDeleteModalShow(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getCategoryStyle()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
            })
            .catch((e) => {
                setSubLoader(false)
                errorResponse(e);
            });
    };

    return (
        <>

            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}> <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); modalOpen(); setStates({}); setSelectedImage("") }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>SubType</th>
                                {/* <th>Created At</th>
                                <th>Updated At</th> */}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr key={index + "categoryStyle"}>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>{Boolean(item?.image) ?
                                            <img className="rounded-circle" style={{ width: '40px' }} src={item?.image} alt="activity-user" />
                                            : "-"}
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.name || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0 text-capitalize">{item?.type_name} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0 text-capitalize">{item?.sub_type_name} </h6>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                {/* <div className='cursor-pointer' onClick={() => setViewModalShow(true)}>
                                                <i className="feather icon-eye" title='View' />
                                            </div> */}
                                                <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); modalOpen() }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                <div className='cursor-pointer' onClick={() => { setDeleteData(item?.slug); setDeleteModalShow(true) }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={7} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />
            }

            {/* add modal */}
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            {Boolean(subLoader) && <Loader loading={subLoader} />}
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter product shape name here" required value={states?.name || ""} name='name' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter product shape name.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className={`mb-3 ${!Boolean(mode) && "align-items-center"}`} as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        Image
                                    </Form.Label>
                                    <Col sm={9}>
                                        {/* {Boolean(mode) ?
                                            <InputGroup className="mb-3">
                                                <Form.Control aria-describedby="custom-addons6" type="file" className="custom-file-input" id="validatedCustomFile2" required name='image' onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">Please select image.</Form.Control.Feedback>
                                            </InputGroup>
                                            : */}
                                        <div className="position-relative" id="profile_image">
                                            <div className="d-flex">
                                                <img
                                                    src={selectedImage || states?.image}
                                                    onClick={handleImageClick}
                                                    className={`cursor-pointer profile-image`}
                                                />
                                            </div>
                                            <input
                                                type="file"
                                                accept=".jpg, .jpeg, .png, webm, .webp"
                                                name="image"
                                                style={{ display: "none" }}
                                                ref={fileInputRef}
                                                onChange={handleChange}
                                            />

                                            <img
                                                src={camera}
                                                onClick={handleImageClick}
                                                className="cursor-pointer position-absolute top-50 start-20 translate-middle"
                                                alt=""
                                            />
                                        </div>
                                        {/* } */}
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Type
                                    </Form.Label>
                                    <Col sm={9}>
                                        <InputGroup className="mb-3">
                                            <FormControl as="select" aria-describedby="custom-addons1" className="custom-select text-capitalize" value={states?.type || ""} name='type' onChange={(e) => {
                                                getMainCategory(e.target.value); handleChange(e);
                                            }}>
                                                <option value={""} disabled>Choose main type</option>
                                                {Boolean(mainCategoryData?.length) &&
                                                    mainCategoryData?.map((item, index) => <option value={item?.slug} className='text-capitalize'>{item?.name}</option>)}
                                            </FormControl>
                                        </InputGroup>
                                    </Col>
                                </Form.Group>

                                {Boolean(subCategoryData?.length) &&
                                    <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                        <Form.Label column sm={3}>
                                            Sub Type
                                        </Form.Label>
                                        <Col sm={9}>
                                            <InputGroup className="mb-3">
                                                <FormControl as="select" aria-describedby="custom-addons1" className="custom-select text-capitalize" value={states?.subType || ""} name='subType' onChange={handleChange}>
                                                    <option value={""} disabled>Choose sub type</option>
                                                    {Boolean(subCategoryData?.length) &&
                                                        subCategoryData?.map((item, index) => <option value={item?.slug} className='text-capitalize'>{item?.name}</option>)}
                                                </FormControl>
                                            </InputGroup>
                                        </Col>
                                    </Form.Group>
                                }

                                <div className='d-flex justify-content-end'>
                                    <Button type='submit' className='m-0'>{Boolean(mode) ? "Save" : "Update"} </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

            {/* Delete */}
            <Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            {Boolean(subLoader) && <Loader loading={subLoader} />}
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deleteCategoryStyle()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CategoryStyle